import { State } from 'model/State';
import { polling } from 'util/mac/api/account/poll';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { downloadLicensesOverviewCSV } from 'util/mac/downloadCSV';

const MIGRATION_POLLING_DURATION = 165000;
const DEFAULT_POLLING_DURATION = 60000;
const POLLING_INTERVAL = 2000;

export const getDownloadCsvForEndUserLicenses = async (
  pollingUuid: string,
  isMigration: boolean,
  partnerId: string,
  state: State,
) => {
  const maxPollingDuration = isMigration ? MIGRATION_POLLING_DURATION : DEFAULT_POLLING_DURATION;
  fetchWithParamValidation(
    async ({ id }) => {
      const remainingPath = `/getOverviewsAsync/poll/${id}`;

      const response = await polling(remainingPath, maxPollingDuration, POLLING_INTERVAL, state);

      if (response?.overviews?.length > 0) {
        downloadLicensesOverviewCSV(response?.overviews, isMigration, partnerId);
      }
    },
    {
      id: pollingUuid,
    },
  );
};
